module.exports = __webpack_public_path__ + "img/product.ecb8ff5a.png";